export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl() {
    switch (window.location.host) {
      case 'sita.wecr.wur.nl':
        return 'https://sita.wecr.wur.nl/WebApi'
      case 'acc.sita.wecr.wur.nl':
        return 'https://acc.sita.wecr.wur.nl/WebApi'
      case 'tst.sita.wecr.wur.nl':
        return 'https://tst.sita.wecr.wur.nl/WebApi'

      case 'sita.wser.wur.nl':
        return 'https://sita.wser.wur.nl/WebApi'
      case 'acc.sita.wser.wur.nl':
        return 'https://acc.sita.wser.wur.nl/WebApi'
      case 'tst.sita.wser.wur.nl':
        return 'https://tst.sita.wser.wur.nl/WebApi'

      default:
        return 'http://localhost:50256'
    }
  }
}
